<template>
  <section id="food" class="food">
    <!-- タイトル・サブタイトル -->
    <div class="text-wrapper">
      <h1 class="title">{{ $t('page.food.title') }}</h1>
      <div class="sub-title">{{ $t('page.food.sub-title') }}</div>
    </div>

    <!-- トップ画像 -->
    <div class="top-content">
      <div class="top-visual">
        <img class="image" src="~/assets/pages/food/ImageFood.webp" alt="" />
      </div>
    </div>

    <!-- メインコンテンツ -->
    <div class="main-content">
      <div class="row">
        <div class="main-visual">
          <img class="image" src="~/assets/pages/food/ImageFoodFeature01.webp" alt="" />
        </div>
        <div class="sub-text">
          <p
            v-for="(text, index) in $tm('page.food.food-content.texts')"
            v-html="$rt(text)"
            class="text"
            :key="index"
          />
        </div>
      </div>
      <div class="row-2">
        <div class="sub-text-2">
          <p
            v-for="(text, index) in $tm('page.food.food-content-2.texts')"
            v-html="$rt(text)"
            class="text"
            :key="index"
          />
        </div>
        <!-- 画像ボックス -->
        <div class="sub-visual-box">
          <div class="sub-visual-box-left">
            <img class="image" src="~/assets/pages/food/ImageFoodFeature02.webp" alt="" />
          </div>
          <div class="sub-visual-box-right">
            <img class="image" src="~/assets/pages/food/ImageFoodFeature03.webp" alt="" />
          </div>
        </div>
      </div>
      <div class="background" />
      <div class="mask" />

      <!-- 注意事項 -->
      <div class="attention-wrapper">
        <div class="attention">
          <p v-html="$rt($t('page.food.attention'))" />
        </div>
      </div>

      <!-- 日帰りBBQ -->
      <div class="title title-optional">{{ $t('page.food.optional-menu-title') }}</div>
      <div class="sub-text-optinal">
        <div class="subject" v-html="$t('page.food.optional-menu-sub-title')"></div>
        <div class="sub-visual-box">
          <img class="image" src="~/assets/pages/food/ImageFoodFeatureWide01.webp" alt="" />
        </div>
        <p class="text" v-html="$t('page.food.optional-menu-texts')"></p>
      </div>
        <!-- 予約サイトへ -->
        <div class="reserve-content">
          <button class="button" @click="clickReservedForm">
            {{ $t('page.reserve.reserved-status-bbq') }}
          </button>
        </div>

    </div>
  </section>
</template>
<script setup lang="ts">
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'
import { actionExternalNewTabTransition, externalTransitionType } from "~/models/Utility";
const { locale } = useI18n()
const clickReservedForm = () => {
  const url = externalTransitionType.reserve_bbq[locale.value];
  actionExternalNewTabTransition(url);
}
</script>
<style lang="scss" scoped>
@use '@/assets/styles/mixins' as m;
@use '@/assets/styles/variables' as v;
@use '@/assets/styles/util' as u;

#food {
  width: 100%;
  text-align: center;
  background: v.$common-white-color;
  padding-top: 120px;
  @include m.sp() {
    padding-top: 64px;
  }
}

.text-wrapper {

  .title {
    color: v.$accent-color;
    font-size: 1.125rem;
    font-family: v.$accent-font-family;
    font-weight: v.$font-weight-light;
    margin: 0;
    @include m.sp() {
      font-size: 1rem;
      letter-spacing: 6.4px;
    }
  }

  .sub-title {
    color: v.$text-title-color;
    font-size: 1.375rem;
    @include m.sp() {
      font-size: 1.25rem;
      letter-spacing: 3px;
    }
  }
}

.top-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 96px auto 128px;
  max-width: 1280px;
  @include m.sp() {
    margin: 64px auto 0;
    padding: 0;
  }

  .top-visual {
    @include m.sp() {
      padding: 0;
    }
  }
}

.main-content {
  width: 100%;
  position: relative;
  padding: 99px 0 100px 0;
  align-items: center;
  @include m.sp() {
    padding: 64px 0 64px 0;
  }

  .background {
    position: absolute;
    inset: 0;
    background: v.$bg-accent2-color;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    height: 100%;
    width: 100%;
    z-index: 0;
  }

  .mask {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 1;
    background: url(~/assets/pages/common/BgTexture01.webp) center/cover no-repeat;
    opacity: 0.08;
    mix-blend-mode: multiply;
  }

  .title,
  .subject,
  .text,
  .main-visual,
  .sub-visual-box,
  .attention {
    position: relative;
    z-index: 2;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: calc(1280px + 6%);
    padding: 0 3%;
    margin: 0 auto;
    gap: 20px;
    @include m.sp() {
      flex-direction: column;
    }

    .main-visual {
      max-width: 520px;
      @include m.sp() {
        max-width: 45vw;
        margin: 0 auto;
      }
    }
  }

  .row-2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    max-width: calc(1280px + 6%);
    padding: 0 3%;
    margin: 160px auto 0;
    @include m.sp() {
      flex-direction: column-reverse;
      margin: 32px auto 0;
    }
  }

  .title {
    flex-wrap: wrap;
    font-size: 1.125rem;
    height: 100%;
    align-content: center;
    font-family: v.$accent-font-family;
    font-weight: v.$font-weight-light;
    color: v.$text-title-color;
    /* padding-bottom: 61px; */
    letter-spacing: 7.2px;
  }

  .sub-text {
    text-align: left;
    max-width: 640px;
    align-content: center;
    word-break: keep-all;
    margin:0 24px;
    @include m.sp() {
      text-align: center;
      padding-left: 0;
    }

    .subject {
      font-size: 1.5rem;
      @include m.sp() {
        font-size: 1.25rem;
      }
    }

    .text {
      font-size: 1rem;
      line-height: 2.4;
      @include m.sp() {
        font-size: 0.875rem;
        margin-top: 32px;
      }
    }
  }

  .sub-text-2 {
    text-align: left;
    align-content: center;
    padding-left: 50px;
    @include m.sp() {
      text-align: center;
      padding-left: 0;
    }

    .text {
      font-size: 1rem;
      line-height: 2.4;
      word-break: keep-all;
      @include m.sp() {
        font-size: 0.875rem;
      }
    }
  }

  .sub-visual-box {
    display: flex;
    align-items: center;
    @include m.sp() {
      margin-left: 0;
    }

    .sub-visual-box-left {
      flex: 1;
      display: flex;
    }

    .sub-visual-box-right {
      display: flex;
      flex-direction: column;
      gap: 14px;
      margin-left: 14px;
      flex: 1;
      @include m.sp() {
        gap: 6px;
      }
    }
  }

  .attention-wrapper {
    margin: 0 auto;
    max-width: calc(1280px + 6%);
    padding: 0 3%;

    .attention {
      font-size: 0.875rem;
      color: v.$text-base-color;
      line-height: 2.4;
      border: solid 1px v.$common-element-color;
      margin: 64px auto 60px;
      padding: 40px 80px;
      @include m.sp() {
        font-size: 0.8125rem;;
        margin: 16px 16px 60px;
        padding: 0 16px;
      }

      p {
        text-align: left;
      }
    }
  }

    /* OPTIONAL MENUコンテンツ用 */
    .title-optional {
      margin-top:128px;
    }
    .sub-text-optinal {
      padding: 16px 3% 0;
      max-width: calc(1280px + 6%);
      margin: 0 auto;
      height: 100%;
      align-content: center;
      @include m.sp() {
        padding: 0 16px 32px;
      }

      .subject {
        font-size: 1.5rem;
        line-height: 2.3;
        margin-bottom: 64px;
        word-break: keep-all;
        letter-spacing: 0.15em;
        @include m.sp() {
          font-size: 1.25rem;
          margin-bottom: 32px;
        }
      }

      .text {
        font-size: 1rem;
        margin-top: 64px;
        line-height: 2.4;
        word-break: keep-all;
        @include m.sp() {
          font-size: 0.875rem;
          margin-top: 32px;
          letter-spacing: 2.1px;;
        }
      }
    }

    .reserve-content {
      width: 328px;
      height: 48px;
      margin: 64px auto 0;
      z-index: 1;
      @include m.sp() {
        max-width: 272px;
        width: 100%;
        margin: 0 auto;
      }

      .button {
        position: relative;
        color: v.$text-base-color;
        font-size: 1rem;
        width: 328px;
        height: 48px;
        border: 1px solid v.$common-element-color;
      }
      &:hover {
        .button {
          color: v.$common-white-color;
          background: v.$accent-color;
          border: none;
          width: 328px;
          height: 48px;
          @include m.sp() {
            max-width: 272px;
            width: 100%;
          }

          &::after {
            opacity: 1;
            transition: all 0.2s;
            /* じわっとサイズが大きくなるアニメーション */
            transform: translate(-50%, -50%) scale(1.015, 1.08);
          }
        }
      }

      @include m.sp() {
        .button {
          color: v.$common-white-color;
          background: v.$accent-color;
          border: none;
          max-width: 272px;
          width: 100%;
          height: 48px;
        }
      }
    }

}
</style>
